import React, { useState , useEffect} from 'react';
import { useMenu } from '../components/context/MenuContext';
import { Box, Typography, Grid, Card, CardContent, CardMedia, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const industries = [  
  { name: "Banking & Finance Services", id: "banking", icon: "/images/banking.jpg", description: "Banking is the backbone of the global economy, offering services such as loans, savings accounts, and wealth management." },
  { name: "Capital Markets", id: "capitalMarkets", icon: "/images/capital.jpg", description: "Capital markets involve the buying and selling of securities like stocks and bonds, helping businesses raise capital." },
  { name: "Communications, Media, and Information Services", id:"communications", icon: "/images/communication.jpeg", description: "This industry focuses on the exchange of information, including telecom services, media, and content distribution." },
  { name: "Energy, Resources, and Utilities",id:"energy", icon: "/images/energy.avif", description: "This sector focuses on energy production, including renewable energy, oil, and utilities such as water and electricity." },
  { name: "Healthcare",id:"Healthcare", icon: "/images/healthcare.jpg", description: "Healthcare covers medical services, pharmaceuticals, and technology aimed at improving the health and wellbeing of people." },
  { name: "Manufacturing",id:"Manufacturing", icon: "/images/manufracturing.jpeg", description: "Manufacturing involves the production of goods from raw materials, often through industrial processes and factories." },
  { name: "Retail",id:"Retail", icon: "/images/retail.webp", description: "Retail involves the sale of goods to consumers directly, including online and in-store shopping experiences." },
  { name: "Travel & Logistics",id:"Travel", icon: "/images/travel.webp", description: "Travel and logistics deal with the movement of goods and people across various modes of transport, including air, land, and sea." },
  { name: "Automative & Aerospace and Defense ", id:"Defense", icon: "/images/defence.webp", description: "We serve the Automotive, Aerospace, and industrial sectors, where artificial intelligence and machine learning (AI/ML) are increasingly leveraged for edge data processing." },
  
];

const Industries = () => {
  const [showAll, setShowAll] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState(null);  // Track the selected industry for detailed view

  const { selectedSubItem } = useMenu(); // Access the selected submenu item from context

  useEffect(() => {
    if (selectedSubItem) {
      // Find the matching capability from the context submenu selection
      const selected = industries.find(
        (capability) => capability.id === selectedSubItem
      );
      setSelectedIndustry(selected);
    }
  }, [selectedSubItem]);

  const handleViewMore = () => {
    setShowAll(!showAll);
  };

  const handleIndustryClick = (index) => {
    setSelectedIndustry(industries[index]);  // Set the selected industry
  };

  const handleBackClick = () => {
    setSelectedIndustry(null);  // Clear selected industry and return to the grid
  };

  const displayedIndustries = showAll ? industries : industries.slice(0, 6);

  return (
    <div>
      <Box sx={{ padding: 4 }}>
        {/* If an industry is selected, show its detailed view */}
        {selectedIndustry ? (
          <Box sx={{ textAlign: 'center' }}>
            
            <Button variant="contained" color="primary" onClick={handleBackClick} sx={{ marginBottom: 4 }}>
            <ArrowBackIcon sx={{ marginRight: 1 }} />  Back to Industries
            </Button>

            <Typography variant="h4" gutterBottom>
              {selectedIndustry.name}
            </Typography>
            <Card sx={{ maxWidth: 600, margin: 'auto' }}>
              <CardMedia
                component="img"
                image={selectedIndustry.icon}
                alt={selectedIndustry.name}
                loading="lazy"
                sx={{
                  height: 300,
                  width: '100%',
                  objectFit: 'cover',
                }}
              />
              <CardContent>
                <Typography variant="body1" align="center">
                  {selectedIndustry.description}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        ) : (
          // If no industry is selected, show the grid view
          <Box>
            <Typography variant="h4" gutterBottom align="center">
              Select Your Industry. Discover Our Impact.
            </Typography>

            <Grid container spacing={4} justifyContent="center">
              {displayedIndustries.map((industry, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card
                    sx={{
                      boxShadow: 3,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      padding: 1,
                      overflow: 'hidden',
                      position: 'relative',
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': { transform: 'scale(1.05)' },
                    }}
                    onClick={() => handleIndustryClick(index)}  // Handle industry click
                  >
                    <CardMedia
                      component="img"
                      image={industry.icon}
                      alt={industry.name}
                      loading="lazy"
                      sx={{
                        height: 140,
                        width: '100%',
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': { transform: 'scale(1.1)' },
                      }}
                    />
                    <CardContent>
                      <Typography variant="h7" align="center">
                        {industry.name}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

            <Box sx={{ textAlign: 'center', marginTop: 4 }}>
              <Button variant="contained" color="primary" onClick={handleViewMore}>
                {showAll ? 'View Less' : 'View More'}
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default Industries;
